import React, { Component } from "react";
import { Card, Row, Col, Button, Form, Input, Spin } from "antd";
import moment from "moment";
import "./searchMember.css";
import UltimateLogo from "../images/ReportLogos/UltimateLogo.png";
import mirranew from "../images/new_mirra_logo.png";
import ARKSS from "./../images/ReportLogos/ARKSS.png";
import DignityHealthPlan from "./../images/ReportLogos/Dignity-Health-Plan.png";
import kaloslogo from "./../images/ReportLogos/kaloslogo.png";
import PODAmericalogo from "./../images/ReportLogos/PODAmericalogo.png";
import SonderLogo from "./../images/ReportLogos/SonderLogo.png";
import ChaptersLogo from "./../images/ReportLogos/chapterslogo.png";
import SolisLogo from "./../images/ReportLogos/Solis-New LOGO 2025.png";
import securLogo from '../images/ReportLogos/SCR-SECUR-VerticalColorLogo.png';
import ChaptershospiceIcon from "../images/ReportLogos/chaptershospiceIcon.png";
import LibertyAdvantage from "./../images/ReportLogos/LibertyAdvantage.png";
import valorlogo from "./../images/ReportLogos/valorlogo.png";
import cshLogo from '../images/ReportLogos/cshLogo.png';

class PrintEligibility extends Component {
  render() {
    return (
      <div
        className="page"
        style={{
          padding: "20px",
          border: "15px double green",
          width: "315mm",
          minHeight: "444mm",
          position: "relative",
        }}
      >
        <Row>
          <Col span={6}>
            {sessionStorage.getItem("planName") === "demo" ? null : (
              <img
                src={
                  sessionStorage.getItem("planName") === "ultimate"
                    ? UltimateLogo
                    : sessionStorage.getItem("planName") === "kalos"
                    ? kaloslogo
                    : sessionStorage.getItem("planName") === "arkss"
                    ? ARKSS
                    : sessionStorage.getItem("planName") === "valor"
                    ? valorlogo
                    : sessionStorage.getItem("planName") === "PodAmerica"
                    ? PODAmericalogo
                    : sessionStorage.getItem("planName") === "sonder"
                    ? SonderLogo
                    : sessionStorage.getItem("planName") === "solis"
                    ? SolisLogo
                    : sessionStorage.getItem("planName") === "chapters"
                    ? ChaptersLogo
                    : sessionStorage.getItem("planName") === "liberty"
                    ? LibertyAdvantage
                    : sessionStorage.getItem("planName") === "dignity"
                    ? DignityHealthPlan
                    : sessionStorage.getItem("planName") === "secur"
                    ? securLogo
                    : sessionStorage.getItem("planName") === "chaptershospice"
                    ? ChaptershospiceIcon
                    : sessionStorage.getItem("planName") === "csh"
                    ? cshLogo
                    : null
                }
                alt="ultimate logo"
                width="200px"
              />
            )}
          </Col>
          <Col span={18} style={{ marginTop: "78px" }}>
            <span
              style={{
                fontSize: "2em",
                color: "#002060",
                padding: "10px 40px",
                backgroundColor: "white",
                marginLeft: "16%",
              }}
            >
              Member Eligibility File
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: "40px" }}>
          <Col span={24}>
            <span
              style={{
                color: "white",
                backgroundColor: "#00B050",
                display: "inherit",
                width: "100%",
                textAlign: "center",
              }}
            >
              Member Information
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={12}>Member ID: {this.props.memberID}</Col>
          <Col span={12}>
            Inquiry Date: {moment(new Date()).format("MM/DD/YYYY")}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            Member Last Name:{" "}
            {this.props.MemberInfo.LastName
              ? this.props.MemberInfo.LastName
              : "- - - - - -"}
          </Col>
          <Col span={12}>
            Member First Name:{" "}
            {this.props.MemberInfo.FirstName
              ? this.props.MemberInfo.FirstName
              : "- - - - -"}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            Member Phone #:{" "}
            {this.props.MemberInfo.PhoneNumber
              ? this.props.MemberInfo.PhoneNumber
              : "- - - - -"}
          </Col>
          <Col span={12}>
            Member DOB:{" "}
            {this.props.MemberInfo.DateOfBirth
              ? this.props.MemberInfo.DateOfBirth
              : "- - - - -"}
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            Member Address:{" "}
            {this.props.MemberInfo.AddressLine1
              ? this.props.MemberInfo.AddressLine1
              : "- - - - -"}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            Plan Name:{" "}
            {this.props.MemberInfo.PlanName
              ? this.props.MemberInfo.PlanName
              : "- - - - -"}
          </Col>
          <Col span={12}>
            Plan Effective Date:
            {this.props.MemberInfo.PlanEffectiveDate
              ? this.props.MemberInfo.PlanEffectiveDate
              : "- - - - -"}{" "}
            -{" "}
            {this.props.MemberInfo.PlanTerminationDate
              ? this.props.MemberInfo.PlanTerminationDate
              : "- - - - -"}
          </Col>
        </Row>

        <Row style={{ marginTop: "40px" }}>
          <Col span={24}>
            <span
              style={{
                color: "white",
                backgroundColor: "#00B050",
                display: "inherit",
                width: "100%",
                textAlign: "center",
              }}
            >
              Primary Care Provider Information
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={12}>
            Assigned PCP:{" "}
            {this.props.MemberInfo.PcpName
              ? this.props.MemberInfo.PcpName
              : "- - - - -"}
          </Col>
          <Col span={12}>
            PCP Effective Date:{" "}
            {this.props.PCPHistoryInfo[0]
              ? moment(this.props.PCPHistoryInfo[0].effectiveFrom).format(
                  "MM/DD/YYYY"
                )
              : "- - - - -"}
            -{" "}
            {this.props.PCPHistoryInfo[0]
              ? moment(this.props.PCPHistoryInfo[0].effectiveTo).format(
                  "MM/DD/YYYY"
                )
              : "- - - - -"}
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            Provider Phone #:{" "}
            {this.props.MemberInfo.PcpPhone
              ? this.props.MemberInfo.PcpPhone
              : "- - - - -"}
          </Col>
          <Col span={12}>Provider Address:</Col>
        </Row>
        <Row>
          <Col span={24}>PCP IPA Affiliation:</Col>
        </Row>

        <Row style={{ marginTop: "40px" }}>
          <Col span={24}>
            <span
              style={{
                color: "white",
                backgroundColor: "#00B050",
                display: "inherit",
                width: "100%",
                textAlign: "center",
              }}
            >
              Primary Care Provider History
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col span={24}>
            <div className="p-2 pb-3">
              <Row className="member-info-header">
                <Col span={4}>PCP Name </Col>
                <Col span={4}>Effective Date </Col>
                <Col span={4}>Termination Date </Col>
                <Col span={6}>PCP's Phone Number </Col>
                <Col span={6}>PCP's Address </Col>
              </Row>
            </div>
            {this.props.PCPHistoryInfo.map((item) => {
              return (
                <Row className="p-2 row-details mb-2">
                  <Col span={4}>
                    {item.pcpFirstName && item.pcpMiddleName && item.pcpLastName
                      ? item.pcpFirstName +
                        item.pcpMiddleName +
                        item.pcpLastName
                      : item.pcpFirstName && item.pcpLastName
                      ? item.pcpFirstName + item.pcpLastName
                      : item.pcpFirstName
                      ? item.pcpFirstName
                      : item.pcpLastName
                      ? item.pcpLastName
                      : "- - - -"}
                  </Col>
                  <Col span={4}>
                    {item.effectiveFrom
                      ? moment(new Date(item.effectiveFrom)).format(
                          "MM/DD/YYYY"
                        )
                      : "- - - -"}{" "}
                  </Col>
                  <Col span={4}>
                    {item.effectiveTo
                      ? moment(new Date(item.effectiveTo)).format("MM/DD/YYYY")
                      : "- - - -"}{" "}
                  </Col>
                  <Col span={6}>
                    {item.phoneNumber ? item.phoneNumber : "- - - -"}{" "}
                  </Col>
                  <Col span={6}>
                    {item.addressLine1 ? item.addressLine1 : "- - - -"}{" "}
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>

        <div style={{ position: "absolute", bottom: "15px" }}>
          <span>
            Payment is subject to Verification of member eligibility on date of
            services rendered, benefit coverage, and appropriate coding
            guidelines.
          </span>
        </div>
      </div>
    );
  }
}

export default PrintEligibility;
